const MOBILE_USER_AGENT = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

/**
 * The device type for the client's first render (theme, useScreenSize).
 *
 * A server-rendered page carries the device type its markup was rendered with
 * (server/renderer.js), and hydration only succeeds with exactly that one — so
 * it wins over anything the browser could work out itself. Without SSR (the
 * Cordova app, `yarn dev`) nothing is hydrated and the user agent decides.
 *
 * @returns {'mobile' | 'desktop'}
 */
export const getClientDeviceType = () => {
  const ssrDeviceType = window.__SSR_DEVICE_TYPE__;
  if (ssrDeviceType === 'mobile' || ssrDeviceType === 'desktop') {
    return ssrDeviceType;
  }
  return MOBILE_USER_AGENT.test(navigator.userAgent) ? 'mobile' : 'desktop';
};
